(() => {
  const themeButtons = document.querySelectorAll('[data-megma-theme-toggle]');
  const updateThemeButtons = () => {
    const dark = document.documentElement.dataset.megmaTheme === 'dark';
    themeButtons.forEach(button => {
      const label = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', label);
      button.title = label;
    });
  };
  updateThemeButtons();
  themeButtons.forEach(button => button.addEventListener('click', () => {
    const next = document.documentElement.dataset.megmaTheme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.megmaTheme = next;
    try { localStorage.setItem('megma-theme', next); } catch (error) { /* Browsers can block storage. */ }
    updateThemeButtons();
  }));
  try {
    matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      if (localStorage.getItem('megma-theme')) return;
      document.documentElement.dataset.megmaTheme = event.matches ? 'dark' : 'light';
      updateThemeButtons();
    });
  } catch (error) { /* The saved choice and toggle still work. */ }

  const header = document.querySelector('.megma-header');
  if (!header) return;
  const menus = header.querySelectorAll('.megma-nav details, .megma-mobile-nav');
  const closeMenus = (except) => menus.forEach(menu => { if (menu !== except) menu.open = false; });
  menus.forEach(menu => {
    menu.addEventListener('toggle', () => { if (menu.open) closeMenus(menu); });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
  });
  document.addEventListener('click', event => { if (!header.contains(event.target)) closeMenus(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus.forEach(menu => { if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  });

  const partnershipDialog = document.querySelector('.megma-partnership-dialog');
  if (!partnershipDialog) return;
  let partnershipOpener = null;
  const openPartnership = opener => {
    closeMenus();
    partnershipOpener = opener || null;
    if (!partnershipDialog.open) partnershipDialog.showModal();
    document.documentElement.classList.add('megma-dialog-open');
    (partnershipDialog.querySelector('.megma-partnership__status') || partnershipDialog.querySelector('#megma-partnership-title')).focus({ preventScroll: true });
  };
  header.querySelectorAll('[data-megma-partnership-open]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      openPartnership(link);
    });
  });
  partnershipDialog.querySelector('[data-megma-partnership-close]').addEventListener('click', () => partnershipDialog.close());
  partnershipDialog.addEventListener('click', event => { if (event.target === partnershipDialog) partnershipDialog.close(); });
  partnershipDialog.addEventListener('close', () => {
    document.documentElement.classList.remove('megma-dialog-open');
    if (partnershipOpener?.isConnected) {
      const mobileSummary = partnershipOpener.closest('.megma-mobile-nav')?.querySelector('summary');
      (mobileSummary || partnershipOpener).focus({ preventScroll: true });
    }
    partnershipOpener = null;
  });
  const openFromHash = () => {
    if (location.hash === '#megma-partnership' || location.hash === '#MegmaPartnershipForm') openPartnership(null);
  };
  openFromHash();
  window.addEventListener('hashchange', openFromHash);
})();
